// Mixin for CryptoWallets.vue
import CustomerWalletApis from '@/modules/crypto/services/apis/customer-wallet'
import { toFixed, numberWithCommas } from '@/utils'

let interval
const customerWallet = new CustomerWalletApis()

export default {
  data() {
    return {
      cryptoWallets: [],
      helpers: {
        toFixed,
        numberWithCommas,
      },
      filter: {
        showWithBalance: false,
        search: '',
      },
      show: true,
    }
  },
  watch: {
    'filter.showWithBalance': val => {
      localStorage.setItem('showWithBalance', val)
    },
  },
  computed: {
    filtredWallets() {
      let filtred = this.filter?.showWithBalance
        ? this.cryptoWallets.filter(item => item.quantity > 0)
        : this.cryptoWallets
      filtred = this.filter?.search
        ? filtred.filter(
          item => item.token.toLowerCase().includes(this.filter?.search)
              || item.name.toLowerCase().includes(this.filter?.search),
        )
        : filtred
      return filtred
    },
  },
  mounted() {
    this.getwallets()
    interval = setInterval(() => {
      this.getwallets()
    }, 60000)
    this.filter.showWithBalance = (localStorage.getItem('showWithBalance') === 'true')
  },
  beforeDestroy() {
    clearInterval(interval)
  },
  methods: {
    getwallets() {
      customerWallet.getUserWallets().then(res => {
        const wallets = res.data.results
          .map(item => ({
            ...item,
            depositable: !!item.currency_network.find(i => i.is_deposit),
            withdrawable: !!item.currency_network.find(i => i.is_withdrawal),
          }))
          .sort(
            (a, b) => a.currency_network[0].exchange.position
              - b.currency_network[0].exchange.position,
          )

        this.cryptoWallets = wallets
        this.show = false
      })
    },
    getCoinAvatar(coin) {
      let img = ''
      try {
        // eslint-disable-next-line import/no-dynamic-require, global-require
        img = require(`@/assets/images/currencies/${coin.toLowerCase()}.svg`)
        return img
      } catch (e) {
        // eslint-disable-next-line global-require
        img = require('@/assets/images/currencies/default.svg')
        return img
      }
    },
  },
}
